export class MediaEditorService {
    public static $inject: string[] = [
        "$compile"
    ];

    constructor(private $compile: ng.ICompileService) {}

    public open(media, scope, onUpdate, resourceId?: number) {
        const $childScope = scope.$new();
        $childScope.media = media;
        $childScope.onUpdate = onUpdate;
        $childScope.resourceId = resourceId;

        angular.element(document.body)
            .append(
                this.$compile(`
                    <media-editor
                        media='media'
                        on-update='onUpdate($event)'
                        resource-id='resourceId'
                    ></media-editor>
                `)($childScope)
            );
    }
}
